@if (dataSourceSubscr.data.length > 0) {
<div class="subscriptions-header">
  <h2>{{ 'ORDERS.DASHBOARD.SUBSCRIPTIONS' | translate }}</h2>
  @if (canRevocate) { @if (revocationCustomLink) {
  <a mat-raised-button target="_blank" [href]="revocationCustomLink" [disabled]="isRevocationLoading">
    {{ 'ORDERS.DASHBOARD.REVOCATE' | translate }}
  </a>
  } }
</div>
<table
  mat-table
  multiTemplateDataRows
  matSort
  class="table-margin first-table mat-elevation-z2"
  [dataSource]="dataSourceSubscr"
>
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of displayedColumnsSubscription">
    <th mat-header-cell class="orders-mat-header-cell" *matHeaderCellDef mat-sort-header>
      {{ 'ORDERS.DASHBOARD.' + column.toUpperCase() | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      @if (column === 'invoiceEndDate') { @switch (element['status']) { @case ('CANCELED') { @if
      (shouldShowNextInvoice(element)) {
      {{ element[column] | date : 'dd.MM.yyyy' }}
      } } @case ('ACTIVE') {
      {{ element[column] | date : 'dd.MM.yyyy' }}
      } }} @else {
      {{ mapSubscriptionsStatus(element[column]) }}
      } @if (column === 'endDate') {
      <div class="expand-more-less">
        <mat-icon>{{ element === expandedElement ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsSubscription.length">
      <div
        class="element-detail"
        *ngIf="element === expandedElement"
        [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="element-detail-row">
          <div class="element-description">
            {{ element.description }}
            &nbsp; @if (element.recipient.firstName && element.recipient.lastName) {
            {{ 'ORDERS.DASHBOARD.RECIPIENT' | translate }} {{ element.recipient.firstName }}
            {{ element.recipient.lastName }}
            &nbsp;
            <mat-icon [matTooltip]="'ORDERS.DASHBOARD.RECIPIENT_INFO' | translate">info_outline</mat-icon>
            }
            <span class="element-description-attribution"></span>
          </div>
          <div class="button-container">
            @if (hasComplaintFeature) {
            <button mat-raised-button (click)="makeComplaint(element)">
              {{ 'ORDERS.DASHBOARD.COMPLAINT' | translate }}
            </button>
            } @if (hasCancellationFeature) { @if (customCancellationLink) {
            <a
              class="cancellation-button"
              target="_blank"
              mat-raised-button
              [href]="customCancellationLink"
              [disabled]="element.status.toUpperCase() === 'CANCELED' || element.status.toUpperCase() === 'INACTIVE'"
            >
              {{ 'ORDERS.DASHBOARD.CANCEL' | translate }}
            </a>
            } @else {
            <button
              class="cancellation-button"
              (click)="cancel(element)"
              mat-raised-button
              [disabled]="
                element.status.toUpperCase() === 'CANCELED' ||
                element.status.toUpperCase() === 'INACTIVE' ||
                cancellationIsLoading
              "
              [class.button-spinner]="cancellationIsLoading"
            >
              {{ 'ORDERS.DASHBOARD.CANCEL' | translate }}
            </button>
            } } @if (canRevocate) { @if (!revocationCustomLink) {
            <button
              mat-raised-button
              (click)="revocate(element)"
              [disabled]="
                element.status.toUpperCase() === 'CANCELED' ||
                element.status.toUpperCase() === 'INACTIVE' ||
                isRevocationLoading
              "
              [class.button-spinner]="isRevocationLoading"
            >
              {{ 'ORDERS.DASHBOARD.REVOCATE' | translate }}
            </button>
            }} @if (allowChangePaymentMethod && canChangeOrderPaymentMethod(element)) {
            <button
              mat-raised-button
              [disabled]="element.status.toUpperCase() === 'CANCELED' || element.status.toUpperCase() === 'INACTIVE'"
              (click)="openPaymentMethods(element)"
            >
              {{ 'ORDERS.CHANGE_PAYMENT_METHOD_BUTTON' | translate }}
            </button>
            } @if (hasInvoiceDownloadFeature) {
            <button
              mat-raised-button
              [disabled]="invoicesCurrentlyDownloading.includes(element.uuid)"
              (click)="downloadInvoices(element)"
              [class.button-spinner]="invoicesCurrentlyDownloading.includes(element.uuid)"
            >
              {{ 'ORDERS.DOWNLOAD_INVOICE' | translate }}
              <!--                              <span *ngIf="!isLoading">{{ 'ORDERS.DOWNLOAD_INVOICE' | translate }}</span>-->
              <!--                              <span class="download-invoice-spinner"-->
              <!--                                ><mat-spinner *ngIf="isLoading" diameter="30" color="primary"></mat-spinner-->
              <!--                              ></span>-->
            </button>
            }
          </div>
          <!--            &lt;!&ndash; <div>-->
          <!--              {{ 'ORDERS.CURRENT_PAYMENT_METHOD' | translate }}:-->
          <!--              {{ (getPaymentMethod(element.paymentId) | async)?.ZAHLWEG_NAME }}-->
          <!--              <button color="primary" mat-button (click)="openPaymentMethods(element)">-->
          <!--                {{ 'ORDERS.CHANGE_PAYMENT_METHOD_BUTTON' | translate }}-->
          <!--              </button>-->
          <!--            </div> &ndash;&gt;-->
        </div>
        <div
          *ngIf="element?.promotions?.length > 0"
          class="element-detail-row-promotion element-detail-row-promotion-header"
        >
          {{ 'ORDERS.DASHBOARD.DIGITAL_PROMOTIONS' | translate }}:
        </div>
        <div *ngFor="let promotion of element.promotions; let i = index" class="element-detail-row-promotion">
          <div>{{ promotion.attribute_name }}</div>
          <div *ngIf="promotion.download_url" class="cancellation-button-container">
            <button
              class="cancellation-button"
              mat-raised-button
              [disabled]="promotionsCurrentlyDownloading.includes(i)"
              (click)="downloadArticle(promotion.download_url, i)"
              [class.button-spinner]="promotionsCurrentlyDownloading.includes(i)"
            >
              {{ 'ORDERS.DOWNLOAD_ARTICLE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumnsSubscription"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: displayedColumnsSubscription"
    class="element-row"
    [class.expanded-row]="expandedElement === element"
    (click)="onOpenDetail(element); $event.stopPropagation()"
  ></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
</table>
<mat-paginator
  #paginatorSubscr
  [length]="dataSourceSubscr.data.length"
  [hidePageSize]="true"
  [pageSize]="10"
  showFirstLastButtons
  aria-label="Select page of periodic elements"
></mat-paginator>

<div *ngIf="environment.ordersLinks.subscriptions.html" [innerHTML]="environment.ordersLinks.subscriptions.html"></div>
<br />
} @if (dataSourceArt.data.length > 0) {
<h2>{{ 'ORDERS.DASHBOARD.ARTICLES' | translate }}</h2>
<table mat-table multiTemplateDataRows matSort class="table-margin" [dataSource]="dataSourceArt">
  <ng-container matColumnDef="{{ column }}" *ngFor="let column of displayedColumnsArticle">
    <th mat-header-cell class="orders-mat-header-cell" *matHeaderCellDef mat-sort-header>
      {{ 'ORDERS.DASHBOARD.' + mapPotentialOrderDate(column) | translate }}
    </th>
    <td mat-cell *matCellDef="let element">
      {{ mapArticle(element[column], column) }}
      <div *ngIf="column === 'status'" class="expand-more-less">
        <mat-icon>{{ element === expandedElement ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="expandedDetail">
    <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsArticle.length">
      <div
        *ngIf="element === expandedElement"
        class="element-detail"
        [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
      >
        <div class="element-detail-row">
          <div class="element-description">
            {{ element.description }}
            <span class="element-description-attribution"></span>
          </div>
          <div class="button-container">
            @if (hasComplaintFeature) {
            <button mat-raised-button (click)="makeComplaint(element)">
              {{ 'ORDERS.DASHBOARD.COMPLAINT' | translate }}
            </button>
            } @if (hasInvoiceDownloadFeature) {
            <button
              class="cancellation-button"
              mat-raised-button
              [disabled]="invoicesCurrentlyDownloading.includes(element.uuid)"
              (click)="downloadInvoices(element)"
              [class.button-spinner]="invoicesCurrentlyDownloading.includes(element.uuid)"
            >
              {{ 'ORDERS.DOWNLOAD_INVOICE' | translate }}
            </button>
            }
            <button
              *ngIf="element.downloadUrl"
              mat-raised-button
              [disabled]="articlesCurrentlyDownloading.includes(element.uuid)"
              (click)="downloadArticle(element.downloadUrl, undefined, element.uuid)"
              [class.button-spinner]="articlesCurrentlyDownloading.includes(element.uuid)"
            >
              {{ 'ORDERS.DOWNLOAD_ARTICLE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumnsArticle"></tr>
  <tr
    mat-row
    *matRowDef="let element; columns: displayedColumnsArticle"
    class="element-row"
    [class.expanded-row]="expandedElement === element"
    (click)="onOpenDetail(element); $event.stopPropagation()"
  ></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row expanded-row"></tr>
</table>
<mat-paginator
  #paginatorArt
  [length]="dataSourceArt.data.length"
  [hidePageSize]="true"
  [pageSize]="10"
  showFirstLastButtons
  aria-label="Select page of periodic elements"
></mat-paginator>
<div *ngIf="environment.ordersLinks.single.html" [innerHTML]="environment.ordersLinks.single.html"></div>
}
